import { service, service2 } from "./service";

export function availablePropertiesApi(payload) {
  return service2.post("v3/listing/available-properties", payload);
}

export function suggestedPropertiesApi() {
  return service.get("v3/properties/listing/featured-properties");
}
